import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const StatisticsByRefererActions = {
    searchData(params, callback) {
        dispatch({
            type  : AppConstants.STATISTICS_SEARCH_START_LOADING,
            params
        });

        api.getReportByReferer(params)
            .then(data => {
                const responseData = data.response && data.response.response ? data.response.response : (data.response || {});
                dispatch({
                    type  : AppConstants.STATISTICS_SEARCH_SUCCESS,
                    items : responseData
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.STATISTICS_SEARCH_FAIL,
                        error: err
                    });
                });
            });
    }
};

export default StatisticsByRefererActions;
